import React, { useState } from "react";
import EfficiencyChart from "./EfficiencyChart";
import { Card, CardHeader, CardTitle, CardContent } from "components/ui/card";

export default function DashboardEfficiencyGraph({
  salesData,
  isLoading,
  interval,
}) {
  const [metric, setMetric] = useState("gross_margin");

  return (
    <Card className="bg-muted/40 border-border/60">
      <CardHeader>
        <CardTitle>Efficiency & Profitability</CardTitle>
      </CardHeader>

      <CardContent>
        <div className="flex gap-2 mb-3">
          {[
            ["gross_margin", "Gross Margin %"],
            ["cost_per_unit", "Cost / Unit"],
            ["profit_growth", "Profit Growth %"],
          ].map(([key, label]) => (
            <button
              key={key}
              onClick={() => setMetric(key)}
              className={`px-3 py-1 rounded-md text-sm border ${
                metric === key
                  ? "bg-yellow-300 text-black"
                  : "border-border/60"
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        {!isLoading && (
          <EfficiencyChart
            salesData={salesData}
            metric={metric}
            interval={interval}
          />
        )}
      </CardContent>
    </Card>
  );
}